import { styled } from '@airwallex/theme';
import { css } from '@emotion/core';

export const TopBox = styled('div')(() => {
  return css`
    background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
    height: 196px;
    position: relative;
  `;
});

export const ImageWrapper = styled('div')(
  ({ theme }) => css`
    position: absolute;
    bottom: -${theme.space.l};
    left: 50%;
    transform: translate(-50%);
  `
);

export const Content = styled('div')(
  ({ theme }) => css`
    text-align: center;
    margin-top: ${theme.space.xl};
  `
);
